import { parseUrl } from 'query-string';
import { EXPOSITION_ID_LENGTH, DEFAULT_EXPOSITION_ID } from '../shared/utils';
import * as BABYLON from 'babylonjs'
import Participant from "./scripts/models/Participant";
import Vec3 from '../shared/vec3';
import ShadowGenerator = BABYLON.ShadowGenerator;
import Scene = BABYLON.Scene;


let player: Participant;
let shadowGenerator: ShadowGenerator;
let scene: Scene;
let engine: BABYLON.Engine;

let colorConfig = {
  hairColor: '#9e4915',
  skinColor: '#ffd9b5',
  shirtColor: '#42648f'
}

const configInStorage = localStorage.getItem('colorConfig');

if (configInStorage) {
  colorConfig = JSON.parse(configInStorage);
}

initializeColorInputs()
initScene();
renderPlayer();


function initializeColorInputs() {
  const hairColorInput: HTMLInputElement = document.getElementById('hairColor') as HTMLInputElement
  const skinColorInput: HTMLInputElement = document.getElementById('skinColor') as HTMLInputElement
  const shirtColorInput: HTMLInputElement = document.getElementById('shirtColor') as HTMLInputElement

  hairColorInput.value = colorConfig.hairColor;
  skinColorInput.value = colorConfig.skinColor;
  shirtColorInput.value = colorConfig.shirtColor;

  handleColorChange('hairColor', (newColor: string) => colorConfig.hairColor = newColor);
  handleColorChange('skinColor', (newColor: string) => colorConfig.skinColor = newColor);
  handleColorChange('shirtColor', (newColor: string) => colorConfig.shirtColor = newColor);
}

function handleColorChange(id: string, onChange: Function) {
  const input: HTMLInputElement = document.getElementById(id) as HTMLInputElement
  input.addEventListener('change', (e: InputEvent) => {
    // @ts-ignore
    onChange(e.target.value);
    localStorage.setItem('colorConfig', JSON.stringify(colorConfig))
    removePlayer();
    renderPlayer();
  });
}

function initScene() {
  const canvas = document.getElementById('scene') as HTMLCanvasElement;
  engine = new BABYLON.Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true });
  const scene = new BABYLON.Scene(engine);

  scene.clearColor = BABYLON.Color4.FromHexString('#ffffffff');

  const ground = BABYLON.Mesh.CreateGround('ground1', 20, 20, 2, scene, false);
  ground.receiveShadows = true;
  const groundMaterial = new BABYLON.StandardMaterial("groundMaterial", scene);
  groundMaterial.diffuseColor = BABYLON.Color3.FromHexString('#e2f2ff');
  ground.material = groundMaterial;

  const camera = new BABYLON.ArcRotateCamera("camera", -Math.PI / 1.6, Math.PI / 2.5, 4.5, new BABYLON.Vector3(0, 0.75, 0), scene);
  camera.attachControl(canvas, true);

  const mainLight = new BABYLON.HemisphericLight('mainLight', new BABYLON.Vector3(-0.5, 1, -1), scene);
  mainLight.intensity = .8;

  const dirLight = new BABYLON.DirectionalLight("DirectionalLight", new BABYLON.Vector3(2, -0.8, 2), scene);
  dirLight.intensity = 0.5;

  shadowGenerator = new BABYLON.ShadowGenerator(2048, dirLight);
  shadowGenerator.usePoissonSampling = true;
  shadowGenerator.useBlurExponentialShadowMap = true;

  engine.runRenderLoop(function () {
    scene.render();
  });
}

function renderPlayer() {
  const playerState = {
    name,
    ping: 0,
    position: new Vec3(0, 0, 0),
    direction: new Vec3(0, 0, 0),
    isWalking: false,
    colors: colorConfig
  }

  player = new Participant('me', playerState, scene, shadowGenerator, false)
}

function removePlayer() {
  player.participantMesh.dispose();
}


const expositionIdFromQueryParam = parseUrl(window.location.href).query.expositionId;
if (expositionIdFromQueryParam) {
  fetchParticipants(expositionIdFromQueryParam as string);
} else {
  fetchParticipants(DEFAULT_EXPOSITION_ID)
}

document.getElementById("joinExpositionButton").addEventListener('click', handleJoin);

function handleJoin() {
  const participantNameField = document.getElementById("participantName") as HTMLInputElement;
  const participantName = participantNameField.value.trim();

  const expositionId = DEFAULT_EXPOSITION_ID;

  if (participantName.length < 2) {
    alert("Error: Name too short");
  } else if (expositionId && expositionId.length >= EXPOSITION_ID_LENGTH) {
    syncSessionStorage(expositionId, participantName)

    console.log("Join exposition " + expositionId + " as " + participantName);
    window.location.href = `exposition.html?expositionId=${ expositionId }`;
  } else {
    alert("Error: No exposition identifier was entered!");
  }
}

async function fetchParticipants(expositionId: string) {
  const expositionInfoResponse = await fetch(`/api/expositions/${ expositionId }`);
  const json = await expositionInfoResponse.json();
  const participants = json.exposition.participants;
  const isFull = json.exposition.isFull;

  if (participants) {
    renderParticipantsList(participants);
  }

  const joinButton = document.getElementById("joinExpositionButton") as HTMLInputElement;
  joinButton.disabled = isFull;
  joinButton.style.display = isFull ? 'none' : 'block';
  const fullNote = document.getElementById("fullNote") as HTMLElement;
  fullNote.style.display = isFull ? 'block' : 'none';
}

function renderParticipantsList(participants: any[]) {
  const participantsElem = document.getElementById('info');

  let text: string;
  if (participants.length === 0) {
    text = 'Aktuell bist du allein auf der Messe. Sag all deinen Freunden und Kollegen bescheid, damit ihr die Expo gemeinsam erkunden könnt!'
  } else {
    text = 'Erkunde die Expo zusammen mit deinen Freunden und Kollegen. <b>'

    if (participants.length === 1) {
      text += participants[0].name + '</b> wartet schon auf dich.'
    } else {
      text += participants.slice(0, participants.length - 1).map(p => p.name).join(', ') + ' und ' + participants[participants.length - 1].name
      text += '</b> warten schon auf dich.'
    }
  }
  participantsElem.innerHTML = `<p>${ text }</p>`;
}

function syncSessionStorage(expositionId: string, participantName: string) {
  sessionStorage.setItem('expositionId', expositionId);
  sessionStorage.setItem('participantName', participantName);
  sessionStorage.removeItem('myParticipantId');
}


document.getElementById("openPopup").addEventListener('click', openPopup);
document.getElementById("close").addEventListener('click', closePopup);

export function openPopup() {
  document.querySelector('form').style.display = 'initial';
  engine.resize();
}

export function closePopup() {
  document.querySelector('form').style.display = 'none';
}